<template>
  <div class="error-404">
    <h1>{{$t('error.404.title')}}</h1>
    <p>{{$t('error.404.text')}}</p>
    <p>{{$t('error.404.support')}} <b><a :href="`mailto:${appInfo.cc_email}`">{{ appInfo.cc_email }}</a></b></p>
  </div>
</template>

<script>
import info from '~/data/info.json';

export default {
  name: 'error-404',
  props: {
    error: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      appInfo: info
    }
  }
}
</script>